import React, { createContext, useContext, useEffect, useState } from 'react';
import { currentYearMonth } from '@/lib/format';

const PeriodCtx = createContext(null);
export const usePeriod = () => useContext(PeriodCtx);

export function PeriodProvider({ children }) {
  const [{ year, month }, setYM] = useState(() => {
    try {
      const s = localStorage.getItem('resico:ym');
      if (s) return JSON.parse(s);
    } catch {}
    return currentYearMonth();
  });

  useEffect(() => {
    localStorage.setItem('resico:ym', JSON.stringify({ year, month }));
  }, [year, month]);

  const setPeriod = (y, m) => setYM({ year: y, month: m });

  return (
    <PeriodCtx.Provider value={{ year, month, setPeriod }}>
      {children}
    </PeriodCtx.Provider>
  );
}
